// 보이는 DOM 패널(영웅 초상·체력 바, 목표, 미니맵, 마을 의뢰 카드, 지역 안내 카드)이 차지한 화면 사각형(CSS px, 뷰포트 기준).
// (ui/screenReserve는 HUD가 피해 숫자용으로 따로 쓰는 고정 슬롯이다. 이 모듈은 월드 이름표용 DOM 공급 함수 목록이다.)
// 렌더의 월드 이름표가 이 영역 밑으로 들어가 글자가 잘리지 않게 옆으로 비켜 그리는 데 쓴다(20261020-world-npc, 루프 D01).
// UI가 공급 함수를 등록하고 렌더가 매 프레임 읽는다. 게임 판정과 무관하다.
import { viewRect } from './viewport';

export interface ScreenRect { x: number; y: number; w: number; h: number }

const sources = new Map<string, () => ScreenRect | null>();

/** id로 공급 함수를 등록(같은 id면 교체)하거나 null로 지운다. 공급 함수는 숨김이면 null을 돌려준다 */
export function setPanelRect(id: string, source: (() => ScreenRect | null) | null): void {
  if (source) sources.set(id, source); else sources.delete(id);
  version++;
}

/** 렌더 루프가 nowMs를 넘기면 이 간격 안에서는 지난 결과를 그대로 쓴다(getBoundingClientRect가 매 프레임 레이아웃을 강제하지 않게) */
export const PANEL_RECTS_CACHE_MS = 150;
let cached: ScreenRect[] = [];
let cachedAt = -Infinity;
let cachedVersion = -1;
let version = 0;

/** 지금 보이는 예약 사각형 목록(너비·높이 0은 뺀다). nowMs를 주면 PANEL_RECTS_CACHE_MS 동안 같은 목록을 돌려준다(등록이 바뀌면 바로 다시 읽는다) */
export function panelRects(nowMs?: number): ScreenRect[] {
  if (nowMs !== undefined && cachedVersion === version && nowMs - cachedAt >= 0 && nowMs - cachedAt < PANEL_RECTS_CACHE_MS) return cached;
  const out: ScreenRect[] = [];
  for (const f of sources.values()) {
    const r = f();
    if (r && r.w > 0 && r.h > 0) out.push(r);
  }
  if (nowMs !== undefined) { cached = out; cachedAt = nowMs; cachedVersion = version; }
  return out;
}

/** DOM 요소용 공급 함수: display:none이거나 크기가 없으면 null */
export function elementRect(el: HTMLElement): () => ScreenRect | null {
  return () => {
    if (el.style.display === 'none' || !el.isConnected) return null;
    // 게임 화면 좌표(세로로 든 기기에서 #app을 돌렸으면 돌린 좌표): 렌더의 화면 투영과 같은 좌표계
    const r = viewRect(el);
    return r.width > 0 && r.height > 0 ? { x: r.left, y: r.top, w: r.width, h: r.height } : null;
  };
}
